import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {LogicEvents, RealityCheckEvents, SlotSettings, Store, Timer} from '@gongxigames/framework/slot';
import {slotStore} from '@gongxigames/framework/slotV2/globals';
import {uiAutoplayOptionsStore} from '@gongxigames/framework/slotV2/ui/services/UIAutoplayOptions/uiAutoplayOptionsStore';
import {setAutoplaySpinsToZero} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class AutoplayDelayBetweenSpinsUIAct extends SyncUIActDecorator {
    private timer!: Timer;
    public static readonly TIME_BEFORE_NEXT_SPIN: number = 500;
    public execute(): void {
        const isFirstAutoplaySpin = Store.computed(() =>
            uiAutoplayOptionsStore.autoplayValues.value.includes(
                slotStore.autoplayOptions.value?.autoplaySpins ?? -1
            )
        );

        const roundDelay = (this.settings as SlotSettings).get('roundDelay') || AutoplayDelayBetweenSpinsUIAct.TIME_BEFORE_NEXT_SPIN;

        if (slotStore.isAutoplay.value && !isFirstAutoplaySpin.value) {
            this.timer = this.updateManager.addTimer(() => {
                this.onExecuted?.();
            }, roundDelay, true);

            this.eventManager.on(LogicEvents.REALITY_CHECK, () => {
                this.stopAutoplay();
                this.onExecuted?.();
            }, this);

            this.eventManager.on(RealityCheckEvents.SHOWED, () => {
                this.stopAutoplay();
                this.onExecuted?.();
            }, this);

            this.eventManager.on('Autoplay.STOP', () => {
                this.stopAutoplay();
                this.onExecuted?.();
            }, this);

            this.emitter.on('UI.stopAutoplayButton.pressed', () => {
                slotStore.isAutoplayStop.value = false;
                this.stopAutoplay();
                this.onExecuted?.();
            });
        } else {
            this.onExecuted?.();
        }
    }

    protected stopAutoplay(): void {
        setAutoplaySpinsToZero();

        if (this.timer && this.timer.isPlaying) {
            this.timer.stop();
        }
    }

    getName(): string {
        return 'AutoplayDelayBetweenSpinsUIAct';
    }
}